export default __webpack_public_path__ + "static/impulse@2x-21949e2609bfd22601539bd32ad6d49f.png";